import axios from 'axios'

import Vue from 'vue'
import Vuex from 'vuex'
import activecampaign from './activecampaign'
import VuexPersist from 'vuex-persist'
import {
  ENABLE_TOOLBAR, DISABLE_TOOLBAR, START, ACCEPT_TERMS, LOADING, SET_USER, SET_HORSE,
  SET_VET, SET_FARRIER, SET_RATION_ID, SET_RATION, SET_STDRATION_INFO, SET_LANGUAGE, SET_REMEMBER_FLAG, SET_HELP, SET_BREEDTYPE_IDX, SET_BREED, SET_BREED_IDX, SET_BREEDS, SET_HORSE_WEIGHT, SET_WEIGHT_ID, SET_WEIGHTS, SET_PHASETYPE_IDX, SET_PHASE, SET_PHASE_IDX, SET_PHASES, SET_ACTIVITYTYPE_IDX, SET_ACTIVITY, SET_ACTIVITY_IDX, SET_ACTIVITIES, SET_NUTRIENTS, SET_AVAILABLE_NUTRIENTS, SET_SELECTED_NUTRIENTS, ERROR, CLEAR_ERROR} from '@/constants/store'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: 'vuex',
  storage: window.localStorage,
  reducer: state => ({
    user: state.user,
    horse: state.horse,
    vet: state.vet,
    farrier: state.farrier,
    language: state.language,
    userID: state.userID
  })
})

const MYCAVALOR_URL = 'https://www.mycavalor.com/mycavalor'
// const MYCAVALOR_URL = 'http://localhost:8790/mycavalor'
const RATION_URL = 'https://www.equinerationcalculator.com/rations'

const store = new Vuex.Store({
  modules: {
    activecampaign
  },
  plugins: [vuexLocalStorage.plugin],
  state: {
    loading: false,
    hostID: 2,
    userID: -1,
    std_uid: 455,
    profileID: 3,
    acceptTerms: true,
    toolbar: false,
    user: { name: '', email: '', phone: '' },
    horse: { name: '', weight: 0 },
    vet: { name: '', phone: '' },
    farrier: { name: '', phone: '' },
    languages: [
      { key: 'en', label: 'English' },
      { key: 'nl', label: 'Nederlands' },
      { key: 'fr', label: 'Français' },
      { key: 'de', label: 'Deutsch' },
      { key: 'es', label: 'Español' }
    ],
    language: 'en',
    rememberMe: true,
    // breed
    breedTypeIdx: undefined,
    breed: {},
    breedIdx: undefined,
    breeds: [],
    // weight
    weight: 0,
    weights: [],
    // phases
    phaseTypeIdx: -1,
    phase: {},
    phaseIdx: -1,
    phases: [],
    // activities
    activityTypeIdx: -1,
    activity: {},
    activityIdx: -1,
    activities: [],
    // ration
    rationID: -1,
    ration: {},
    // nutrients
    nutrients: [],
    available_nutrients: [],
    selected_nutrients: [],
    info: {},
    help: {},
    error: {},
    images: {
      breed: [
        '/static/img/horse-warmblood1.png',
        '/static/img/horse-thoroughbred1.png',
        '/static/img/horse-coldblood1.png',
        '/static/img/horse-pony1.png'
      ],
      phase: [
        '/static/img/horse-breeding1.png',
        '/static/img/horse-performance1.png',
        '/static/img/horse-senior1.png'
      ],
      activity: [
        '/static/img/horse-activity-sport1.png',
        '/static/img/horse-activity-recreation1.png',
        '/static/img/horse-activity-rest1.png'
      ],
      attention: [
        '/static/img/horse-no-ailment.png',
        '/static/img/horse-with-ailment.png'
      ]
    },
    plan: [
      /* KV */
      [ [1, 0, 0], [2, 0, 2], [3, 3, 3] ],
      /* RV */
      [ [1, 0, 0], [2, 0, 2], [3, 3, 3] ],
      /* Sup */
      [ [1, 0, 0], [2, 0, 2], [3, 3, 3] ]
    ]
  },
  mutations: {
    [START] (state) {
      state.breedTypeIdx = undefined
      state.breed = {}
      state.breedIdx = undefined
      // weight
      state.weight = 0
      // phases
      state.phaseTypeIdx = -1
      state.phase = {}
      state.phaseIdx = -1
      // activities
      state.activityTypeIdx = -1
      state.activity = {}
      state.activityIdx = -1
      // ration
      state.rationID = -1
      state.ration = {}
    },
    [LOADING] (state, load) {
      state.loading = load
    },
    [ACCEPT_TERMS] (state, choice) {
      state.acceptTerms = choice
    },
    [SET_LANGUAGE] (state, language) {
      state.language = language
    },
    [SET_REMEMBER_FLAG] (state, flag) {
      state.rememberMe = flag
    },
    [ENABLE_TOOLBAR] (state) {
      state.toolbar = true
    },
    [DISABLE_TOOLBAR] (state) {
      state.toolbar = false
    },
    [SET_HELP] (state, text) {
      state.help = text
    },
    [SET_BREEDTYPE_IDX] (state, id) {
      state.breedTypeIdx = id
    },
    [SET_BREED] (state, id) {
      state.breed = id
    },
    [SET_BREED_IDX] (state, id) {
      state.breedIdx = id
    },
    [SET_BREEDS] (state, breeds) {
      state.breeds = breeds
    },
    [SET_HORSE_WEIGHT] (state, weight) {
      state.horse.weight = weight
    },
    [SET_WEIGHT_ID] (state, weight) {
      state.weight = weight
    },
    [SET_WEIGHTS] (state, weights) {
      state.weights = weights
    },
    [SET_PHASETYPE_IDX] (state, id) {
      state.phaseTypeIdx = id
    },
    [SET_PHASE] (state, phase) {
      state.phase = phase
    },
    [SET_PHASE_IDX] (state, id) {
      state.phaseIdx = id
    },
    [SET_PHASES] (state, phases) {
      state.phases = phases
    },
    [SET_ACTIVITYTYPE_IDX] (state, id) {
      state.activityTypeIdx = id
    },
    [SET_ACTIVITY] (state, activity) {
      state.activity = activity
    },
    [SET_ACTIVITY_IDX] (state, id) {
      state.activityIdx = id
    },
    [SET_ACTIVITIES] (state, activities) {
      state.activities = activities
    },
    [SET_AVAILABLE_NUTRIENTS] (state, nutrients) {
      state.available_nutrients = nutrients.split(',')
    },
    [SET_NUTRIENTS] (state, nutrients) {
      state.nutrients = nutrients
    },
    [SET_USER] (state, user) {
      state.user = user
    },
    [SET_HORSE] (state, horse) {
      state.horse = horse
    },
    [SET_VET] (state, vet) {
      state.vet = vet
    },
    [SET_FARRIER] (state, farrier) {
      state.farrier = farrier
    },
    [SET_RATION_ID] (state, id) {
      state.rationID = id
    },
    [SET_RATION] (state, ration) {
      state.ration = ration
    },
    [SET_STDRATION_INFO] (state, info) {
      state.info = info
    },
    [SET_SELECTED_NUTRIENTS] (state, nutrients) {
      state.selected_nutrients = nutrients.split(',')
    },
    [ERROR] (state, error) {
      state.error = error
      state.loading = false
    },
    [CLEAR_ERROR] (state) {
      state.error = {}
    }
  },
  getters: {
    emptyStateLabel: (state) => {
      if (state.loading) {
        return 'Loading data...'
      } else {
        return 'No data found'
      }
    },
    languageLabel: (state) => {
      return (state.languages.find(obj => obj.key === state.language) || {}).label
    },
    horse: (state) => {
      return state.horse || {}
    },
    breedType: (state) => {
      return (state.breeds || []).find(obj => obj.classID === state.breedTypeIdx) || {}
    },
    breed: (state, getters) => {
      return (getters.breedType.breeds || []).find(obj => obj.breedID === state.breedIdx) || {}
    },
    weight: (state) => {
      return (state.weights || []).find(obj => obj.weightID === state.weight) || {}
    },
    weightsByBreedType: (state) => {
      var low = 100
      var high = 1200
      var weights = []

      switch (state.breedTypeIdx) {
        case 1:
          low = 450
          weights = state.weights.filter(obj => obj.value >= low && obj.value <= high)
          break
        case 2:
          low = 450
          weights = state.weights.filter(obj => obj.value >= low && obj.value <= high)
          break
        case 3:
          low = 450
          weights = state.weights.filter(obj => obj.value >= low && obj.value <= high)
          break
        case 4:
          high = 450
          weights = state.weights.filter(obj => obj.value >= low && obj.value <= high)
          break
      }
      return weights
    },
    phaseType (state) {
      return (state.phases || []).find(obj => obj.lifeStateID === state.phaseTypeIdx) || {}
    },
    phase (state, getters) {
      return (getters.phaseType.items || []).find(obj => obj.lifeStateItemID === state.phaseIdx) || {}
    },
    activityType (state) {
      return (state.activities || []).find(obj => obj.lifeStateID === state.activityTypeIdx) || {}
    },
    activity (state, getters) {
      return (getters.activityType.items || []).find(obj => obj.lifeStateItemID === state.activityIdx) || {}
    },
    image: (state) => {
      return (category, index) => state.images[category][index - 1]
    },
    ration: (state) => {
      return state.ration || {}
    },
    allMaterials: (state, getters) => {
      return getters.ration.ration || []
    },
    materials: (state, getters) => {
      return (getters.ration || {}).ration || []
    },
    materialsByType: (state, getters) => {
      return Vue.options.filters.sortBy(getters.materials, function (obj) {
        var res = 0
        switch (obj.type) {
          case 0: res = 1; break
          case 1: res = 0; break
          case 2: res = 2; break
        }
        return res
      })
    },
    rationAnalysis: (state) => {
      return (state.ration || {}).analysis || []
    },
    analysis: (state, getters) => {
      return state.available_nutrients.map(id => getters.rationAnalysis[id] || { ingredientID: id }).filter(obj => obj.norm > 0)
      // return (getters.ration.analysis || []).filter(obj => obj.norm > 0.0)
    },
    nutrients: (state, getters) => {
      return getters.analysis.map(obj => obj.name)
    },
    krachtvoer: (state, getters) => {
      return getters.analysis.map(obj => Vue.options.filters.toFixed(obj.krachtvoer * 1.0 / obj.norm * 100.0, 3))
    },
    ruwvoer: (state, getters) => {
      return getters.analysis.map(obj => Vue.options.filters.toFixed(obj.ruwvoer * 1.0 / obj.norm * 100.0, 3))
    },
    supplement: (state, getters) => {
      return getters.analysis.map(obj => Vue.options.filters.toFixed(obj.supplement * 1.0 / obj.norm * 100.0, 3))
    },
    feedingSchedule: (state, getters) => (mpd) => {
      return getters.materialsByType.map(obj => {
        var morning = state.plan[obj.type][mpd[obj.type] - 1][0]
        var noon = state.plan[obj.type][mpd[obj.type] - 1][1]
        var evening = state.plan[obj.type][mpd[obj.type] - 1][2]
        var toGrams = obj.type === 2 ? 1000 : 1
        return {
          'name': obj.name,
          'type': obj.type,
          'hoeveelheid': toGrams * obj.hoeveelheid,
          'total': toGrams * obj.hoeveelheid,
          'morning': morning === 0 ? 0 : Math.round(toGrams * obj.hoeveelheid / morning * 1000) / 1000,
          'noon': noon === 0 ? 0 : Math.round(toGrams * obj.hoeveelheid / noon * 1000) / 1000,
          'evening': evening === 0 ? 0 : Math.round(toGrams * obj.hoeveelheid / evening * 1000) / 1000,
          'unit': obj.type === 2 ? 'gr' : 'kg'
        }
      })
    }
  },
  actions: {
    async initialize ({dispatch}) {
      await dispatch('getBreeds')
      dispatch('getHelpText')
      await dispatch('getNutrients')
      await dispatch('getAvailableNutrients')
    },
    async setLanguage ({dispatch, state}) {
      dispatch('getHelpText')
      dispatch('getBreeds')
      dispatch('getWeights', { breedID: state.breedIdx })
      dispatch('getPhases', { breedID: state.breedIdx, weightID: state.weight })
      dispatch('getStates', { breedID: state.breedIdx, weightID: state.weight, phaseID: state.phaseTypeIdx, phaseDetailID: state.phaseIdx })
      dispatch('getAdvice', { breedID: state.breedIdx, weightID: state.weight, phaseID: state.phaseTypeIdx, phaseDetailID: state.phaseIdx, stateID: state.activityTypeIdx, stateDetailsID: state.activityIdx })
    },
    async registerUser ({commit, state}, user) {
      return axios.post(MYCAVALOR_URL + '/register', user, { params: { language: state.language } })
        .catch((error) => console.log(error))
    },
    async getBreeds ({ commit, state }) {
      return axios.get(MYCAVALOR_URL + '/breeds', { params: { language: state.language } })
        .then((response) => commit(SET_BREEDS, response.data))
        .catch((error) => commit(ERROR, { message: error }))
    },
    async getWeights ({ commit, state }, data) {
      if (data.breedID === undefined || data.breedIdx <= 0) {
        return
      }
      return axios.get(MYCAVALOR_URL + '/breeds/' + data.breedID + '/weights', { params: { language: state.language } })
        .then((response) => commit(SET_WEIGHTS, response.data))
        .catch((error) => commit(ERROR, { message: error }))
    },
    async getPhases ({ commit, state }, data) {
      if (data.breedID === undefined || data.breedIdx <= 0 ||
          data.weightID === undefined || data.weightID <= 0) {
        return
      }
      return axios.get(MYCAVALOR_URL + '/breeds/' + data.breedID + '/weights/' + data.weightID + '/phases', { params: { language: state.language } })
        .then((response) => commit(SET_PHASES, response.data))
        .catch((error) => commit(ERROR, { message: error }))
    },
    async getStates ({ commit, state }, data) {
      if (data.breedID === undefined || data.breedIdx <= 0 ||
        data.weightID === undefined || data.weightID <= 0 ||
        data.phaseID === undefined || data.phaseID <= 0 ||
        data.phaseDetailID === undefined || data.phaseDetailID <= 0) {
        return
      }
      return axios.get(MYCAVALOR_URL + '/breeds/' + data.breedID + '/weights/' + data.weightID + '/phases/' + data.phaseID + '/' + data.phaseDetailID + '/states', { params: { language: state.language } })
        .then((response) => commit(SET_ACTIVITIES, response.data))
        .catch((error) => commit(ERROR, { message: error }))
    },
    async getAdvice ({ commit, state }, data) {
      commit(LOADING, true)
      if (data.breedID === undefined || data.breedIdx <= 0 ||
        data.weightID === undefined || data.weightID <= 0 ||
        data.phaseID === undefined || data.phaseID <= 0 ||
        data.phaseDetailID === undefined || data.phaseDetailID <= 0 ||
        data.stateID === undefined || data.stateID <= 0 ||
        data.stateDetailsID === undefined || data.stateDetailsID <= 0) {
        return
      }
      return axios.get(MYCAVALOR_URL + '/breeds/' + data.breedID + '/weights/' + data.weightID + '/phases/' + data.phaseID + '/' + data.phaseDetailID + '/states/' + data.stateID + '/' + data.stateDetailsID, { params: { language: state.language, email: state.user.email, horse: state.horse.name, info: true } })
        .then((response) => {
          commit(LOADING, false)
          commit(SET_RATION, response.data)
          commit(SET_RATION_ID, state.ration.rantsoenID)
        })
        .catch((error) => commit(ERROR, { message: error }))
    },
    async getRationInfo ({ commit, state }) {
      var params = {}
      params.language = state.language
      return axios.get(MYCAVALOR_URL + '/info/' + state.rationID, { params: params })
        .then((response) => commit(SET_STDRATION_INFO, response.data))
        .catch((error) => commit(ERROR, { message: error }))
    },
    async getActivities ({ commit, state }) {
      return axios.get(MYCAVALOR_URL + '/activities?language=' + state.language)
        .then((response) => commit(SET_ACTIVITIES, response.data))
        .catch((error) => commit(ERROR, { message: error }))
    },
    async getAvailableNutrients ({ commit, state }) {
      return axios.get(RATION_URL + '/nutrients/hosts/4/profiles/4')
        .then((response) => {
          commit(SET_AVAILABLE_NUTRIENTS, response.data.nutrients)
          commit(SET_SELECTED_NUTRIENTS, response.data.nutrients)
        })
        .catch((error) => commit(ERROR, { message: error }))
    },
    async getNutrients ({ commit }) {
      return axios.get(RATION_URL + '/nutrients')
        .then((response) => commit(SET_NUTRIENTS, response.data))
        .catch((error) => commit(ERROR, { message: error }))
    },
    async getHelpText ({ commit, state }) {
      return axios.get(MYCAVALOR_URL + '/help?language=' + state.language)
        .then((response) => commit(SET_HELP, response.data.name))
        .catch((error) => commit(ERROR, { message: error }))
    },
    async getProductInfo1 ({commit, state}, ean) {
      // ean code should not be empty otherwise a rederict happens...
      return axios.get(MYCAVALOR_URL + '/product/' + ean + '?language=' + state.language)
        .then((response) => {
          return response.data.result
        })
        .catch((error) => {
          commit(ERROR, { message: error })
        })
    },
    async getProductInfo ({commit, state}, ean) {
      // ean code should not be empty otherwise a rederict happens...
      const lngPrefix = state.language !== 'en' ? `${state.language}/` : ''
      return axios.get(`https://cavalor.com/${lngPrefix}wp-json/custom-endpoint/v2/products/${ean}`)
        .then((response) => {
          return response.data[0]
        })
        .catch((error) => {
          throw new Error(error)
        })
    },
    async askTheExpert ({ commit }, data) {
      commit(ERROR, { label: 'email.sending' })
      return axios.post(MYCAVALOR_URL + '/asktheexpert', data)
        .then((response) => {
          commit(ERROR, { label: 'email.sent' })
        })
        .catch(() => commit(ERROR, { label: 'email.fail' }))
    },
    async getBase64 ({commit, state}, ean) {
      return axios.get(MYCAVALOR_URL + '/image/' + ean + '?language=' + state.language)
        .then((response) => {
          return response.data
        })
        .catch((error) => {
          commit(ERROR, { message: error })
        })
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js